var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useState } from 'react';
import { useToast } from '~/components_to_be_packaged/toast/provider';
import { useUser } from '~/providers/user';
import { useWebsocket } from '~/providers/websocket';
import Permissions from '~/settings/permissions';
import { SaveState } from '../enums';
import downloadDocumentsAction from './actions/download_documents';
import updateDocumentMetadataAction from './actions/update_document_metadata';
const RightPanelContext = createContext({});
const RightPanelProvider = (props) => {
    const { hasPermission } = useUser();
    const { showToast } = useToast();
    const ws = useWebsocket();
    const [saveState, setSaveState] = useState(SaveState.READY_TO_SAVE);
    const [updateError, setUpdateError] = useState(null);
    const downloadDocuments = (documents, downloadType) => {
        if (hasPermission(Permissions.DOWNLOAD_DOCUMENT)) {
            downloadDocumentsAction(documents, downloadType, showToast);
        }
    };
    const updateDocumentMetadata = (documentId, metadataFields) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setSaveState(SaveState.SAVING);
            yield updateDocumentMetadataAction(ws, documentId, metadataFields);
            setSaveState(SaveState.RECENTLY_SAVED);
        }
        catch (err) {
            setSaveState(SaveState.ERROR);
            if (err instanceof Error) {
                setUpdateError(err.message);
            }
        }
        setTimeout(() => {
            if (setSaveState)
                setSaveState(SaveState.READY_TO_SAVE);
        }, 2000);
    });
    const value = {
        downloadDocuments,
        updateDocumentMetadata,
        saveState,
        updateError,
    };
    return React.createElement(RightPanelContext.Provider, Object.assign({ value: value }, props));
};
const useRightPanel = () => {
    const context = useContext(RightPanelContext);
    if (!context) {
        throw new Error('RightPanelContext must be used inside of a RightPanelProvider');
    }
    return context;
};
export { RightPanelProvider, useRightPanel, };
